/* ============
 * Product Type Transformer
 * ============
 *
 * The transformer for the producer.
 */

import Transformer from './transformer';

export default class ProducerTransformer extends Transformer {

  static fetch(producer) {
    return {
      id: producer.id,
      name: producer.name,
      typeId: producer.type_id,
    };
  }

  static send(producer) {
    return {
      id: producer.id,
      name: producer.name,
      type_id: producer.typeId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/producer.js